import { motion } from 'framer-motion'

export function BetaStatus() {
  return (
    <section className="relative bg-charcoal-black px-6 py-20 md:py-28">
      <motion.div
        className="relative mx-auto max-w-3xl overflow-hidden rounded-2xl border border-electric-cyan/15 bg-gradient-to-b from-soft-black/80 to-charcoal-black/85 p-8 text-center md:p-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div
          aria-hidden
          className="pointer-events-none absolute -top-px left-1/2 h-px w-1/2 -translate-x-1/2 bg-gradient-to-r from-transparent via-electric-cyan/40 to-transparent"
        />
        <p className="inline-flex items-center gap-2 rounded-full border border-electric-cyan/25 bg-electric-cyan/[0.06] px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em] text-electric-cyan/90">
          <span
            className="h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-electric-cyan"
            aria-hidden
          />
          Status
        </p>
        <h2 className="mt-4 text-[2rem] font-semibold leading-tight tracking-tight text-soft-white md:text-4xl">
          We&apos;re in private beta.
        </h2>
        <p className="text-base md:text-lg text-muted-silver leading-relaxed mt-5">
          Right now, Boomshift is being tested with a small group of trainers and their clients while
          we work out every detail. Self-serve signup opens soon.
        </p>
        <p className="text-base md:text-lg text-muted-silver leading-relaxed mt-3">
          If your trainer already invited you, your access details come directly from them.
        </p>
        <p className="mt-7 text-sm text-muted-silver">
          Looking for a trainer who uses Boomshift? It&apos;s coming soon.
        </p>
      </motion.div>
    </section>
  )
}
